const { isEmpty } = require('lodash');

const isNotEmptyString = (value = '') => value !== '';
const hasAnyContent = (object) => !isEmpty(object);

const LAZY_COMPONENT_REQUIRED_FIELDS = {
    type: isNotEmptyString,
    name: isNotEmptyString,
};

const FULLY_COMPONENT_REQUIRED_FIELDS = {
    ...LAZY_COMPONENT_REQUIRED_FIELDS,
    properties: (properties) => hasAnyContent(properties) && Object.values(properties).map(hasAnyContent).some(Boolean),
};

/**
 * This function searches each of the required fields in the given component
 * @param {object} component - The component to validate
 * @param {bool} isLazy - Determines if the component should have lazy or fully structure
 * @returns Boolean indicates if all required fields are setteled
 */
module.exports = (component, isLazy = false) =>
    Object.entries(isLazy ? LAZY_COMPONENT_REQUIRED_FIELDS : FULLY_COMPONENT_REQUIRED_FIELDS)
        .map(([fieldName, isValid]) => isValid(component[fieldName]))
        .every(Boolean);
